import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const hero = document.getElementById("hero")
    if (!hero) return

    const headerHeight = this.element.offsetHeight

    this.observer = new IntersectionObserver(
      ([entry]) => this.toggleState(entry.isIntersecting),
      { threshold: 0, rootMargin: `-${headerHeight}px 0px 0px 0px` }
    )
    this.observer.observe(hero)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  toggleState(heroVisible) {
    this.element.classList.toggle("header--transparent", heroVisible)
    this.element.classList.toggle("header--solid", !heroVisible)
  }
}
